import { render } from "./RiepilogoDomandeRisposteLog.vue?vue&type=template&id=282d6e83"
import script from "./RiepilogoDomandeRisposteLog.vue?vue&type=script&lang=js"
export * from "./RiepilogoDomandeRisposteLog.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__